import React from "react";
const BannerSection = props => {
  return (
    <div
      className="fullwidth banner-section text-center top-section"
      id="top-section"
    >
      <div className="container">
        <div className="top-section">
          <div className="heading">
            CP FOOD SERVICE <br />
            <span>FAST DELIVERY.</span> RELIABLE SERVICE
          </div>
          <p>
            Servicing restaurants and businesses between Sydney, Central Coast &
            Wollongong. CP Food Service is an importer and distributor of Asian
            and Western food products.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BannerSection;



// WEBPACK FOOTER //
// ./src/components/Home/First-Fold.js